module.exports = __webpack_public_path__ + "static/media/The-Meadows-Amendment-3.f61272ee.pdf";